export const STATUS_MESSAGES: Record<number | "default", string> = {
    400: "發生意外錯誤，請重新嘗試",
    401: "用戶沒有登入系統，請登入",
    403: "用戶沒有當前功能權限",
    404: "請求的資源不存在",
    405: "HTTP 請求方法錯誤，請回報工程團隊修復",
    410: "請求的資源已過期",
    500: "伺服器異常錯誤",
    502: "伺服器服務中出現異常",
    503: "伺服器暫時無法處理請求",
    504: "伺服器沒有回應，請等候後重新嘗試",
    default: "發生意外錯誤，請重新嘗試",
}
